import { useEffect, useState } from 'react';
import { Brand } from '../interface/interface';
import { API } from '../config/config';
import { useAuth } from './useAuth';


export const useBrands = () => {
  const { enhancedFetch } = useAuth();
  const [brands, setBrands] = useState<Brand[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        // Use enhancedFetch
        const data = await enhancedFetch(`${API.HOST}/api/v1/brands`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        })
        if (Array.isArray(data)) {
          setBrands(data);
        } else {
          console.warn('Data type is not an array');
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchBrands().then();
  }, []);

  return { brands, loading, error };

}
